module.exports = __webpack_public_path__ + "static/caseStudyTablet-84d60ac59a2e797ed850aa22290def24.png";